import './header.scss'
import logo from './logo.svg'
import phone from './phone.svg'

function Header() {
    return (
        <header className='header'>
            <img src={logo} alt='logo'/>
            <ul className='menu'>
                <li className='menu__item'>
                    <a href='/' className='link'>Our Services</a>
                </li>
                <li className='menu__item'>
                    <a href='/' className='link'>About</a>
                </li>
                <li className='menu__item'>
                    <a href='/' className='link'>Blog&News</a>
                </li>
                <li className='menu__item'>
                    <a href='/' className='link'>Contact</a>
                </li>
                <li className='menu__item'>
                    <a href='/' className='link'>Account</a>
                </li>
            </ul>
            <div className='line'/>
            <div className='contacts'>
                <img src={phone} alt='phone'/>
                <span className='contacts__phone'>+2349067322844</span>
            </div>
        </header>
    )
}

export default Header
